import type { IconDefinition } from '../index.tsx';

export const iconCircle: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconCircle',
  icon: [512, 512, [], '', 'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'],
};
